import { Modal } from '@/components/Elements';
import { ColDetailList } from './ColDetailList';

export const ColumnSampleDataModal = ({
  isOpen,
  handleClose,
  columnDetails,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={handleClose}
      title={`Sample data for ${columnDetails?.label}`}
      headerClassName="pt-4 px-3"
      titleClassName="text-sm leading-5 text-brand-ai-200 max-w-xs overflow-ellipsis whitespace-nowrap overflow-hidden"
      topStripClassName="hidden"
      topBorderClassname={`border-t-5 border-pv-primary-primary-500`}
      className="min-w-96 w-fit relative"
      closeClassName="right-3 top-4"
    >
      <div className="flex flex-col gap-4 justify-between mb-7">
        <div
          className="p-3 pb-0 flex flex-col gap-2"
          style={{
            width: '550px',
          }}
        >
          <div className="w-full flex flex-col">
            {columnDetails.name?.length > 0 ? (
              <ColDetailList columnDetails={columnDetails} />
            ) : (
              <span>No column details</span>
            )}
          </div>
        </div>
      </div>
    </Modal>
  );
};
